._CommunityPrograms_t2pzk_1 ._text_t2pzk_1 {
  display: block;
  margin-bottom: 15px;
}
._CommunityPrograms_t2pzk_1 ._field_t2pzk_5 {
  max-width: 300px;
}